export const AppCookieNames = {
    GAME_NOT_AVAILABLE_NOTIFICATION: 'asgGameNotAvailableNotification',
    OPEN_POST_LOGIN_GAME_PAGE: 'asgOpenPostLoginGamePage',
    GAME_VERTICAL_ID: 'GameVerticalID',
    CURRENT_VERTICAL_ID: 'currentVerticalId',
    CURRENT_VERTICAL_TYPE: 'currentVerticalType',
};
